import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../../../dialogs/success-snackbar/success-snackbar.component';
import { FacultyModel } from '../../../model/faculty.model';
import { FacultyFellowshipSpecialisationModel } from '../../../model/faculty_fellowship_specialisation.model';
import { FacultyMedicalProcedureCategoryModel } from '../../../model/faculty_medical_procedure_category.model';
import { MedicalProcedureService } from '../../../providers/medical_procedure.service';

@Component({
  selector: 'app-fellowship-cat-edit-dialog',
  templateUrl: './fellowship-cat-edit-dialog.component.html',
  styleUrls: ['./fellowship-cat-edit-dialog.component.css']
})
export class FellowshipCatEditDialogComponent implements OnInit {
  
  errorMessage: string = '';
  isLoading: boolean = true;
  mFaculty:FacultyModel;
  mItems:FacultyMedicalProcedureCategoryModel[]=[]; 
  mFellowshipItems:FacultyMedicalProcedureCategoryModel[]=[]; 
 mMembershipItems:FacultyMedicalProcedureCategoryModel[]=[];
 mFacultyFellowshipSpecialisations:FacultyFellowshipSpecialisationModel[];  
 durationInSeconds = 1;

  selectedItem:FacultyMedicalProcedureCategoryModel;

  constructor(private fb: FormBuilder, private mApiService:MedicalProcedureService,  private _snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<FacultyMedicalProcedureCategoryModel>,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
      this.mFaculty = new FacultyModel()
    }

  ngOnInit(): void {
    this.selectedItem = this.data;
  }

  
saveEdit(){



  console.log(this.selectedItem);
         
          this.mApiService
          .editFcultyMedicalProcedureCategoryItem(this.selectedItem)
          .subscribe(
           p=> 
           {
          
            this.getItemsList(this.mFaculty.Id);
            this.dialogRef.close() ;

            this._snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: this.durationInSeconds * 1000,
            });
            
            
           },
           e => this.errorMessage = e,
           ()=>this.isLoading=false
         )

}


getItemsList(id:string)
{
     this.mItems=[];
     this.isLoading=true;
     

         this.mApiService.getFacultyMedicalProcedureCategoriesItems(id,0)
         .subscribe(
           p=>{this.mItems=p
             this.categoriseItems();
          },
           e => this.errorMessage = e,
           ()=>this.isLoading=false
         )
    
}

categoriseItems(): any {
  this.mFellowshipItems=this.mItems.filter(item=>item.ProgramCategoryId==1);
  this.mMembershipItems=this.mItems.filter(item=>item.ProgramCategoryId==2);
}

}
